import { createActionsHook, StoreActionApi } from 'react-sweet-state';

import {
  createDataHook,
  createGetAction,
  createLoadingHook,
  createRestActions,
  createRestStore,
  RestStoreState,
} from '@intelliarts/ia-react-template';

import { createMutationFailedCheck } from '../../../utils/restMutation';
import { EmployeeStatus } from '../../Employee/models/EmployeeStatus';
import { StatusHistoryWithEmployee } from '../../Employee/models/StatusHistoryWithEmployee';

type BenchPageStoreState = RestStoreState<StatusHistoryWithEmployee>;

const actionConfig = {
  resourcePath: '/status-histories',
};

const genericActions = createRestActions<StatusHistoryWithEmployee>(actionConfig);

const benchPageActions = {
  ...genericActions,
  loadBenchHistories: (from: string, to: string) =>
    async ({ dispatch }: StoreActionApi<BenchPageStoreState>) => {
      const getAction = createGetAction<StatusHistoryWithEmployee>({
        resourcePath: `${actionConfig.resourcePath}?status=${EmployeeStatus.BENCH}&from=${from}&to=${to}`,
      });
      await dispatch(getAction());
    },
};

export const BenchHistoryStore = createRestStore<StatusHistoryWithEmployee>({
  actions: benchPageActions,
  actionConfig,
  containerDisplayName: 'bench-page-container',
  onInitAction: null,
});

export const useBenchPageData = createDataHook(BenchHistoryStore);
export const useBenchPageIsLoading = createLoadingHook(BenchHistoryStore);
export const useBenchPageActions = createActionsHook(BenchHistoryStore);
export const didBenchHistoryMutationFail = createMutationFailedCheck(actionConfig.resourcePath);
